import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { AddressRepository } from '../repositories/address.repository';
import { StatesResponse } from '../models/states-response.model';

export class GetStatesUseCase implements UseCase<number, StatesResponse> {
    constructor(private readonly repository: AddressRepository) {}

    execute(countryId: number): Observable<StatesResponse> {
        return this.repository.getStates(countryId);
    }
}
